import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/web-maintenance.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function Webmaintance() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Regular Updates",
            content: "We handle software, security patches, and plugin updates to ensure your website stays current and compatible with the latest web standards.",
        },
        {
            title: "Bug Fix",
            content: "Our team quickly addresses any technical issues, fixing bugs and glitches to ensure smooth functionality.",
        },
        {
            title: "Performance Optimization",
            content: "We monitor and optimize your website’s speed and overall performance, ensuring fast loading times and enhanced user experience.",
        },
        {
            title: "Security Monitoring",
            content: "We implement security protocols and conduct regular checks to protect your site from potential threats, hacks, and vulnerabilities.",
        },
        {
            title: "Content Updates",
            content: "Whether it’s adding new blog posts, images, or product listings, we keep your website content fresh and aligned with your business needs.",
        },
           {
            title: "BAckup & Recovery",
            content: "Regular website backups ensure that your data is safe and can be easily restored in case of unforeseen events.",
        },
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Proactive Support",
            desc: "We offer proactive monitoring and regular updates, ensuring that potential issues are addressed before they become problems.",
        },
        {
            title: "Security Assurance",
            desc: "Our maintenance services include robust security measures to safeguard your website from cyber threats.",
        },
        {
            title: "Seamless User Expreience",
            desc: "By maintaining your website’s performance, we ensure your visitors enjoy a fast, responsive, and error-free browsing experience.",
        },
        {
            title:"Tailored Solutions",
            desc:"Whether you need simple content updates or extensive technical fixes, our team customizes our services to fit your specific needs."
        }
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>Web Maintenance</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/webmaintance">Web Maintenance</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>Web Maintenance Service</h1>

                            <p>
                               Keep your website running smoothly, securely, and up-to-date with REDITE’s professional website maintenance services. We provide ongoing support to ensure your online presence operates at its best, offering peace of mind and allowing you to focus on what matters most—growing your business.
                            </p>

                            <h3>Comprehensive Website Maintenance Solutions</h3>


                            <p>At REDITE, we understand the importance of a well-maintained website. Our team is committed to providing reliable and timely maintenance services that help keep your site functional, secure, and optimized for performance. From routine updates to emergency bug fixes, we are here to ensure your website stays ahead of the curve. </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>
Our Website Maintenance Services Include:</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>Why Choose REDITE for Website Maintenance?</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Approach: Reliable and Timely Maintenance</h4>
                        <p>
                        REDITE’s website maintenance process is designed to be efficient and non-intrusive, allowing your site to operate without interruption. We ensure regular monitoring and swift responses to any issues, providing you with ongoing support and timely updates.
                        </p>

                        <h4>Keep Your Website Fresh and Secure</h4>
                        <p>
                            With REDITE’s website maintenance services, you can rest assured that your website is in good hands. We help ensure your website stays up-to-date, secure, and optimized, so you can focus on driving your business forward.
                        </p>

                        <p>
                           
                            <span> Contact REDITE today</span>to learn more about how our website maintenance services can support your online presence and enhance your website’s performance.
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default Webmaintance;
